import {
  BloyalState,
  Commerce7State,
  Dynamics365State,
  SalesforceState,
  TripleseatState,
  WineDirectClassicState,
} from 'types/integrations';
import { dashboard } from 'types';
import { toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface GuestIntegrationState {
  isInitialized: boolean;
  isRequestInProgress: boolean;
  tripleseat: TripleseatState;
  commerce7: Commerce7State;
  winedirectclassic: WineDirectClassicState;
  salesforce: SalesforceState;
  dynamics365: Dynamics365State;
  bloyal: BloyalState;
}

const initialState: GuestIntegrationState = {
  isInitialized: false,
  isRequestInProgress: false,
  commerce7: { locations: [], groupTags: [] },
  winedirectclassic: { groupTags: [] },
  tripleseat: { locations: [], rooms: [] },
  salesforce: { groupTags: [] },
  dynamics365: { groupTags: [] },
  bloyal: { groupTags: [] },
};

export default function reducer(
  state: GuestIntegrationState = initialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): GuestIntegrationState {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.COMMERCE7_LIST_LOCATIONS_STARTING: {
      return {
        ...state,
        isRequestInProgress: true,
        commerce7: {
          ...state.commerce7,
        },
      };
    }
    case AppConstants.COMMERCE7_LIST_LOCATIONS_FAILED: {
      return {
        ...state,
        isRequestInProgress: false,
        commerce7: {
          ...state.commerce7,
          locations: [],
        },
      };
    }
    case AppConstants.COMMERCE7_LIST_LOCATIONS_DONE: {
      return {
        ...state,
        isRequestInProgress: false,
        commerce7: {
          ...state.commerce7,
          locations: toJSONArray(payload),
        },
      };
    }
    case AppConstants.TRIPLESEAT_LIST_LOCATIONS_STARTING: {
      return {
        ...state,
        isRequestInProgress: true,
        tripleseat: {
          ...state.tripleseat,
        },
      };
    }
    case AppConstants.TRIPLESEAT_LIST_LOCATIONS_FAILED: {
      return {
        ...state,
        isRequestInProgress: false,
        tripleseat: {
          ...state.tripleseat,
          locations: [],
        },
      };
    }
    case AppConstants.TRIPLESEAT_LIST_LOCATIONS_DONE: {
      return {
        ...state,
        isRequestInProgress: false,
        tripleseat: {
          ...state.tripleseat,
          locations: toJSONArray(payload),
        },
      };
    }
    case AppConstants.TRIPLESEAT_LIST_ROOMS_DONE: {
      return {
        ...state,
        isRequestInProgress: false,
        tripleseat: {
          ...state.tripleseat,
          rooms: toJSONArray(payload),
        },
      };
    }
    case AppConstants.TRIPLESEAT_LIST_ROOMS_STARTING: {
      return {
        ...state,
        isRequestInProgress: true,
        tripleseat: {
          ...state.tripleseat,
        },
      };
    }
    case AppConstants.TRIPLESEAT_LIST_ROOMS_FAILED: {
      return {
        ...state,
        isRequestInProgress: false,
        tripleseat: {
          ...state.tripleseat,
          rooms: [],
        },
      };
    }
    case AppConstants.CLEAR_LOCATIONS: {
      return {
        ...state,
        commerce7: { ...state.commerce7, locations: [] },
        tripleseat: { locations: [], rooms: [] },
      };
    }
    case AppConstants.INTEGRATION_TAGS_DONE: {
      const response: dashboard.IExternalGuestGroupSet[] = toJSONArray(payload);
      const integrationType = response.find((elem) => elem.integrationType)?.integrationType ?? '';
      switch (integrationType) {
        case 'COMMERCE7':
          return { ...state, commerce7: { ...state.commerce7, groupTags: response } };
        case 'WINEDIRECT_CLASSIC':
          return {
            ...state,
            winedirectclassic: { ...state.winedirectclassic, groupTags: response },
          };
        case 'SALESFORCE':
          return { ...state, salesforce: { ...state.salesforce, groupTags: response } };
        case 'DYNAMICS_365':
          return { ...state, dynamics365: { ...state.dynamics365, groupTags: response } };
        case 'BLOYAL':
          return { ...state, bloyal: { ...state.bloyal, groupTags: response } };
        default:
          throw new Error(`${integrationType} does not support smart groups`);
      }
    }
    default:
      return state;
  }
}
